import { MessageCircle } from 'lucide-react';
import type { EpcScheduleTaskRow } from '../../types/scheduleTask';
import { plannedTodayPercent, taskPercent } from '../utils/taskStatus';

function resourceNames(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  const out: string[] = [];
  for (const item of raw) {
    if (!item || typeof item !== 'object') continue;
    const name = String((item as Record<string, unknown>).resourceName ?? '').trim();
    if (name) out.push(name);
  }
  return out;
}

export function TaskProgressCard({
  task,
  today,
  messageCount,
  onOpenDiscussion,
}: {
  task: EpcScheduleTaskRow;
  today: Date;
  messageCount: number;
  onOpenDiscussion: () => void;
}) {
  const pct = Math.max(0, Math.min(100, Math.round(taskPercent(task))));
  const planned = plannedTodayPercent(task, today);
  const resources = resourceNames(task.resourceAssignments);
  return (
    <div className="rounded-xl border border-[#e8edf1] bg-white px-3.5 py-3 shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
      <p className="mb-1.5 text-[9.5px] font-bold uppercase tracking-[0.1em] text-slate-400">Progress</p>
      <div className="flex items-center gap-3.5">
        <div
          className="flex h-[74px] w-[74px] shrink-0 items-center justify-center rounded-full"
          style={{ background: `conic-gradient(#006346 0 ${pct}%, #eef2f6 ${pct}% 100%)` }}
          role="img"
          aria-label={`${pct}% complete`}
        >
          <div className="flex h-[52px] w-[52px] items-center justify-center rounded-full bg-white">
            <span className="text-sm font-extrabold text-slate-900">{pct}%</span>
          </div>
        </div>
        <div className="min-w-0 text-[10.5px] leading-relaxed text-slate-600">
          <p>
            Planned today <b className="text-slate-900">{planned != null ? `${planned}%` : '—'}</b>
          </p>
          <p className="truncate" title={resources.join(' · ')}>
            Resources <b className="text-slate-900">{resources.length ? resources.join(' · ') : '—'}</b>
          </p>
          <button
            type="button"
            onClick={onOpenDiscussion}
            className="inline-flex items-center gap-1 font-semibold text-[#076333] underline-offset-2 hover:underline"
          >
            <MessageCircle className="h-3 w-3" aria-hidden />
            Discussion <b>{messageCount} message{messageCount === 1 ? '' : 's'}</b>
          </button>
        </div>
      </div>
    </div>
  );
}
